<input
  #imageUploadInput
  type="file"
  accept=".svg,image/*"
  hidden
  (change)="onImageSelected($event)"
  (click)="imageUploadInput.value = ''"
/>
